import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const ContentBannerContainer = styled("div")`
    padding: 0 2.5rem 0 2.5rem;

    @media (max-width: ${breakpoints.values.lg}px) {
        padding: 0 2rem 0 2rem;
    }
`
